export default __webpack_public_path__ + "static/media/icon-pickup-point.dafd2804.svg";